module.exports = __webpack_public_path__ + "img/horizontal_7_4_8019.91f1a6c1.png";